// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search_zero_results_help-module__icon--3evM0{background:url(/img/icons/help.svg) no-repeat;fill:#36b;width:16px;height:16px;display:inline-block;vertical-align:middle;margin-right:11px}.search_zero_results_help-module__link--1Ngyr{display:inline-block;color:#36b}.search_zero_results_help-module__link--1Ngyr:hover{text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"icon": "search_zero_results_help-module__icon--3evM0",
	"link": "search_zero_results_help-module__link--1Ngyr"
};
module.exports = exports;
